import type { RefObject } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { StatisticsChart } from './StatisticsChart';
import { CumulativeChart } from './CumulativeChart';
import type { ChartDataRaw } from './StatisticsChart';

type ChartTabsProps = {
  chartDataRaw: ChartDataRaw | null;
  /** Colour slots for the experiment, so every chart gives a variant the same colour. */
  colorOrder: readonly number[];
  goal: string;
  goalLabel?: string;
  chartRef: RefObject<HTMLDivElement | null>;
};

// The active tab takes the foreground; a variant utility outranks `micro-label`'s
// own colour, so the two compose. `text-nano` is restated because the trigger's own
// `text-sm` is a core utility and would otherwise win on order.
const TAB_CLASS =
  'micro-label data-[state=active]:bg-panel data-[state=active]:text-foreground rounded-lg px-3 py-1.5 ' +
  'text-nano transition-colors duration-150';

export const ChartTabs = ({ chartDataRaw, goal, goalLabel, chartRef, colorOrder }: ChartTabsProps) => {
  if (!chartDataRaw) return null;

  return (
    <Tabs defaultValue="daily">
      <TabsList className="bg-field border-line h-auto gap-0.5 rounded-lg border p-0.5">
        <TabsTrigger value="daily" className={TAB_CLASS}>
          Daily
        </TabsTrigger>
        <TabsTrigger value="cumulative" className={TAB_CLASS}>
          Cumulative
        </TabsTrigger>
      </TabsList>
      <TabsContent value="daily">
        <StatisticsChart
          chartDataRaw={chartDataRaw}
          goal={goal}
          goalLabel={goalLabel}
          chartRef={chartRef}
          colorOrder={colorOrder}
        />
      </TabsContent>
      <TabsContent value="cumulative">
        <CumulativeChart chartDataRaw={chartDataRaw} goal={goal} goalLabel={goalLabel} colorOrder={colorOrder} />
      </TabsContent>
    </Tabs>
  );
};
